import { Component, EventEmitter, Input, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Region } from '../../../model/region.model';
import { County } from '../../../model/county';
import { SchoolDistrict } from '../../../model/schoolDistrict.model';
import { School } from '../../../model/school.model';

import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { SearchStudent } from '../model/searchStudent';
import { SearchChildrenService } from '../service/search-children.service';
import { ChildSearchRequestDataView } from '../model/search-child-request-data-view';

import { EditChildComponent } from '../edit-child/edit-child.component';
import { AgePipe } from 'src/app/pipes/age.pipe';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { HelperService } from 'src/app/service/helper.service';
import { Route, SearchCriteria, SearchResult } from 'src/app/model/session-tracking/tracking-type';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { CountyDropdownTwoWayComponent } from '../../common-components/county/county-dropdown-two-way/county-dropdown-two-way.component';
import { DistrictDropdownTwoWayComponent } from '../../common-components/district/district-dropdown-two-way/district-dropdown-two-way.component';
import { RegionDropdownTwoWayComponent } from '../../common-components/region/region-dropdown-two-way/region-dropdown-two-way.component';
import { SchoolDropdownTwoWayComponent } from '../../common-components/school/school-dropdown-two-way/school-dropdown-two-way.component';
import { take } from 'rxjs';

/*
const sortingDataAccessor = (item: SearchStudent, property: string) => {
    switch (property) {
        case 'REGION':
            if (item.REGIONS[0]?.NAME) return item.REGIONS[0]?.NAME?.toString().toLocaleLowerCase();
            else return '';
        case 'LASTNAME':
            if (item.PERSON?.LAST_NAME) return item.PERSON?.LAST_NAME?.toString().toLocaleLowerCase();
            else return '';
        case 'SECONDLASTNAME':
            if (item.SECOND_LAST_NAME) return item.SECOND_LAST_NAME;
            else return '';
        case 'FIRSTNAME':
            if (item?.PERSON.FIRST_NAME) return item?.PERSON.FIRST_NAME;
            else return '';
        case 'MIDDLENAME':
            if (item.PERSON?.MIDDLE_INITIAL) return item.PERSON?.MIDDLE_INITIAL;
            else return '';
        case 'DOB':
            if (item.DOB != undefined) return new Date(item.DOB).getTime();
            else return '';
        case 'GENDER':
            if (item?.SEX) return item?.SEX;
            else return '';
        case 'LMNAME':
            if (item?.LEGAL_MOTHERS?.length > 0 && item?.LEGAL_MOTHERS[0]?.FIRST_NAME)
                return item?.LEGAL_MOTHERS[0].FIRST_NAME + item?.LEGAL_MOTHERS[0].LAST_NAME;
            else return '';
        case 'LFNAME':
            if (item?.LEGAL_FATHERS?.length > 0 && item?.LEGAL_FATHERS[0]?.FIRST_NAME)
                return item?.LEGAL_FATHERS[0].FIRST_NAME + item?.LEGAL_FATHERS[0].LAST_NAME;
            else return '';
        case 'MSD':
            if (item?.MSD_NUMBER) return item.MSD_NUMBER;
            else return '';
        default:
            if (item?.ID) return item.ID;
            else return '';
    }
};
*/

@Component({
    selector: 'app-search-children',
    templateUrl: './search-children.component.html',
    styleUrls: ['./search-children.component.scss']
})
export class SearchChildrenComponent implements OnInit {
    @Input() hideShoppingCart: boolean = false;
    @Input() shoppingCartInput: any[] = [];
    @Input('selectUserRegion') selectUserRegion: boolean = false;
    @Output() shoppingCartChange: EventEmitter<any> = new EventEmitter<any>();

    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild(RegionDropdownTwoWayComponent) regionDropDown!: RegionDropdownTwoWayComponent;
    @ViewChild(CountyDropdownTwoWayComponent) countyDropDown!: CountyDropdownTwoWayComponent;
    @ViewChild(DistrictDropdownTwoWayComponent) districtDropDown!: DistrictDropdownTwoWayComponent;
    @ViewChild(SchoolDropdownTwoWayComponent) schoolDropDown!: SchoolDropdownTwoWayComponent;
    searchStudentForm: UntypedFormGroup;

    family: UntypedFormGroup;
    personalInformation: UntypedFormGroup;

    maxDate: Date;
    minDate: Date;
    startAt: Date;

    lstQuestionHelpText: any[] = [];

    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];

    resetField: boolean = false;
    isLoadingResults: boolean = false;
    disableButton: boolean = false;
    g_bAdvancedFieldsFilled: boolean = false;
    g_filledCount: number = 0;
    public myError: string = '';
    public myInstruction: string = 'Please enter at least two fields when doing a basic search.';

    results: SearchStudent[] = [];
    filter: string = '';
    studentLength: number;

    tableDataSources: MatTableDataSource<SearchStudent>[] = [];
    msg = new MsgModel();

    // Shopping Cart
    shoppingCartTableDataSources: MatTableDataSource<any>[] = [];
    shoppingCartBackup: any = {};
    shoppingCart: any[] = [];
    shoppingCartFilter: string = '';
    shoppingCartLength: number;
    selectRegionIds: number[] = [];
    selectCountyIds: number[] = [];
    selectSchoolDistrictIds: number[] = [];
    selectSchoolIds: number[] = [];

    getPropertyPipe = new GetPropertyPipe();
    getAgePipe = new AgePipe();
    routePath: string;
    screenName: string;
    displayedColumns: string[] = [
        'ACTION',
        'REGIONS[0].CODE',
        'PERSON.LAST_NAME',
        'SECOND_LAST_NAME',
        'PERSON.FIRST_NAME',
        'PERSON.MIDDLE_INITIAL',
        'DOB',
        'SEX',
        'LEGAL_MOTHERS[0].FIRST_NAME',
        'LEGAL_FATHERS[0].FIRST_NAME',
        'MSD_NUMBER'
    ];

    localStorageReset: any;
    locationExpanded: boolean = false;
    familyExpanded: boolean = false;
    personalExpanded: boolean = false;

    constructor(
        private dialog: MatDialog,
        private fb: UntypedFormBuilder,
        private searchChildrenService: SearchChildrenService,
        private helperService: HelperService,
        private datePipe: DatePipe,
        private router: Router
    ) {
        this.routePath = this.router.url;

        if (this.routePath == '/children/search') this.screenName = 'Search Children';
        else if (this.routePath == '/children/group-communication-events' || this.routePath == '/children/group-enrollment') this.screenName = 'secondTab';

        this.searchStudentForm = this.fb.group({
            lastName: [''],
            firstName: [''],
            middleName: [''],
            secondLastName: [''],
            legalMotherFirstName: [''],
            birthCity: [''],
            startDate: new UntypedFormControl(null),
            endDate: new UntypedFormControl(null),
            includeHardTerminations: new UntypedFormControl(false),
            msd: [''],
            coe: [''],
            msix: [''],
            ssid: [''],
            localSISID: [''],

            motherFirstName: [''],
            motherLastName: [''],
            fatherFirstName: [''],
            fatherLastName: [''],

            birthState: [''],
            birthCountry: [''],
            gender: ['']
        });

        const currentYear = new Date().getFullYear();
        this.minDate = new Date(currentYear - 50, 0, 1);
        this.maxDate = new Date();
        this.startAt = new Date();

        // Get localStorageReset
        try {
            this.localStorageReset = JSON.parse(localStorage.getItem('reset') || '{}');
        } catch (e) {
            this.localStorageReset = {};
        }

        // if (this.screenName === 'Search Children') {
        //     this.getBackup();

        //     if (!this.localStorageReset[this.router.url]) {
        //         setTimeout(() => {
        //             if (!!this.shoppingCartBackup.SearchResults) {
        //                 setTimeout(() => {
        //                     this.restoreSearchCriteriaFromBackup();
        //                 }, 200);
        //             }
        //         }, 1000);
        //     }
        // }
    }

    ngOnInit(): void {
        this.searchStudentForm.valueChanges.subscribe((x) => {
            this.myError = '';
            this.disableButton = !this.validateBasicFields() && !this.validateAdvFields() && this.validateFields();
            if (!this.disableButton) this.msg = new MsgModel(); //  !this.g_bAdvancedFieldsFilled)
        });

        // Update button state whenever form values change
        this.searchStudentForm.valueChanges.subscribe(() => {
            this.myError = '';
            this.disableButton = !this.validateBasicFields() && !this.validateAdvFields() && this.validateFields();
        });

        // Get Shopping Cart
        //Bring the previous "footprints/session" data

        /*const s = timer(1000);
        s.subscribe((val) => {
            this.regionDropDown.deSelectAll();
            this.disableButton = true;
        });*/
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['shoppingCartInput']) {
            const currentValue = changes['shoppingCartInput'].currentValue;

            //const previousValue = changes['shoppingCartInput'].previousValue;

            this.shoppingCart = currentValue;

            this.updateDataSource();
            this.updateShoppingCartDataSource();

            this.saveBackup();
        }
    }

    updateDataSource(newSort?: boolean) {
        setTimeout(() => {
            this.tableDataSources = [];

            // Data
            let dataSource = new MatTableDataSource<any>();
            dataSource.data = this.results.filter((r) => !this.shoppingCart.map((sc) => sc.ID).includes(r.ID));

            // Paginator
            dataSource.paginator = this.paginators.toArray()[0];

            // Sort
            dataSource.sort = this.sorts.toArray()[0];
            dataSource.sortingDataAccessor = (obj, property) => {
                // Check if the property is 'MSD_NUMBER' and if it's blank or undefined
                if (property === 'MSD_NUMBER' && (obj[property] === undefined || obj[property] === '')) {
                    // ensures rows of blank MSD_NUMBER sort to the bottom
                    return 'ZZZZZ';
                }
                // Otherwise, use your getPropertyPipe as before
                return this.getPropertyPipe.transform(obj, property, true);
            };

            if (dataSource.sort) {
                if (newSort) {
                    const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
                    dataSource.sort.active = defaultSort.active;
                    dataSource.sort.direction = defaultSort.direction;
                    dataSource.sort.sortChange.emit(defaultSort);
                } else {
                    dataSource.sort.sortChange.emit(this.sorts.toArray()[0]);
                }
            }
            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.tableDataSources.push(dataSource);
        }, 100);
    }

    setFilter() {
        this.tableDataSources.forEach((dataSource, index) => {
            dataSource.filter = this.filter.trim().toLocaleLowerCase();
        });
    }

    constructSearchRequest(includeSearchResult: Boolean): ChildSearchRequestDataView {
        const childSearchRequest = {} as ChildSearchRequestDataView;
        childSearchRequest.studentFirstName = this.firstName.value;
        childSearchRequest.studentLastName = this.lastName.value;
        childSearchRequest.studentMiddleInitial = this.middleName.value;
        childSearchRequest.studentSecondLastName = this.secondLastName.value;
        //childSearchRequest.studentAgeLimit = 22;

        childSearchRequest.studentCity = this.birthCity.value;

        if (this.endDate?.value != null) {
            childSearchRequest.studentDOB = this.startDate.value;
            const diffTime = Math.abs(this.endDate.value.getTime() - this.startDate.value.getTime());
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            childSearchRequest.studentDOBRange = diffDays.toString();
        } else {
            childSearchRequest.studentDOBRange = '0';
        }

        childSearchRequest.studentMsdNumber = this.msd.value;
        childSearchRequest.coeNumber = this.coe.value;
        childSearchRequest.studentSSID = this.ssid.value;
        childSearchRequest.studentSISID = this.localSISID.value;
        childSearchRequest.studentMSIX = this.msix.value;

        if (this.motherFirstName.value == '') childSearchRequest.legalMotherFirstName = this.legalMotherFirstName.value;
        else childSearchRequest.legalMotherFirstName = this.motherFirstName.value;

        childSearchRequest.legalMotherLastName = this.motherLastName.value;
        childSearchRequest.legalFatherFirstName = this.fatherFirstName.value;
        childSearchRequest.legalFatherLastName = this.fatherLastName.value;

        childSearchRequest.studentState = this.birthState.value;
        childSearchRequest.studentCountry = this.birthCountry.value;
        childSearchRequest.studentSex = this.gender.value;

        childSearchRequest.terminationFlag = this.includeHardTerminations.value;

        childSearchRequest.chosenRegions = this.chosenRegions;
        childSearchRequest.chosenCounties = this.chosenCounties;
        childSearchRequest.chosenSchoolDistricts = this.chosenSchoolDistricts;
        childSearchRequest.chosenSchools = this.chosenSchools;

        if (this.shoppingCartBackup.SearchResults && this.shoppingCartBackup.SearchResults.length > 0 && includeSearchResult) {
            childSearchRequest.studentIDs = this.shoppingCartBackup.SearchResults.results; //[0,1]
        }

        return childSearchRequest;
    }

    search(includeSearchResult: Boolean) {
        this.msg = new MsgModel();
        this.isLoadingResults = true;
        //this.dataSource = new MatTableDataSource<SearchStudent>();
        this.disableButton = true;
        if (this.isLoadingResults) {
            const childSearchRequest: ChildSearchRequestDataView = this.constructSearchRequest(includeSearchResult);

            this.searchChildrenService.getSimpleSearch(childSearchRequest).subscribe({
                next: (res) => {
                    if (res.students) {
                        res.students = JSON.parse(res['students']);
                        res.students.forEach((student: any) => {
                            // Attach AGE
                            student.AGE = parseInt(this.getAgePipe.transform(student.DOB).replace(/[{()}]/g, ''));
                        });

                        this.results = res.students.sort((n1: SearchStudent, n2: SearchStudent) => (n1.PERSON.LAST_NAME! > n2.PERSON.LAST_NAME! ? 1 : -1));
                        this.studentLength = res.students.length;

                        let prefixColumns: string[] = [];
                        //console.log("completed in 1st block")
                        //this.displayedColumns = this.generateDisplayColumns(this.selectedSchoolYear, prefixColumns);
                    } else if (res.msg) {
                        this.results = [];
                        this.isLoadingResults = false;
                        this.msg = res.msg;
                        if (res.msg) this.myError = res.msg.MSG;
                        //console.log("completed in 2nd block")
                    } else {
                        this.results = [];
                        this.isLoadingResults = false;
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving children.' };
                        if (this.msg.MSG) this.myError = this.msg.MSG;
                        //console.log("completed in 3rd block")
                    }
                },
                error: (err) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving children.' };
                    if (this.msg.MSG) this.myError = this.msg.MSG;
                },
                complete: () => {
                    // Display current performance period
                    //this.currentSchoolYear = this.selectedSchoolYear;

                    // Updates the Tables to be displayed w/ this.results
                    if (this.results.length > 0) {
                        this.updateDataSource(true);
                        this.updateShoppingCartDataSource();
                    }

                    // Save shopping cart
                    this.restoreShoppingCart();

                    this.saveBackup();

                    // Display results
                    this.isLoadingResults = false;
                }
            });
        }
    }

    reset() {
        this.searchStudentForm.reset();
        this.startDate.value = null;
        this.endDate.value = null;
        this.disableButton = true;
        // this.regionDropDown.deSelectAll();
        // this.countyDropDown.deSelectAll();
        // this.districtDropDown.deSelectAll();
        // this.schoolDropDown.deSelectAll();
        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];

        this.localStorageReset[this.router.url] = true;
        localStorage.setItem('reset', JSON.stringify(this.localStorageReset));
    }

    announceSortChange(sortState: Sort) {
        //this.paginatorEvent();
    }

    view(row: SearchStudent) {
        const dialogRef = this.dialog.open(EditChildComponent, {
            disableClose: true,
            width: '90%',
            height: '90%',
            data: row
        });
        dialogRef.afterClosed().subscribe((x: any) => {});
    }
    edit(row: any) {}

    // paginatorEvent() {
    //     this.dataSource.sortingDataAccessor = sortingDataAccessor;
    //     this.dataSource.sort = this.sort;
    //     this.dataSource.paginator = this.searchPaginator;
    // }

    validateAdvFields() {
        // take into account also of advanced fields which are filled
        const msdVal = this.searchStudentForm.get('msd')?.value;
        const coeVal = this.searchStudentForm.get('coe')?.value;
        const msixVal = this.searchStudentForm.get('msix')?.value;
        const ssidVal = this.searchStudentForm.get('ssid')?.value;
        const localSISIDVal = this.searchStudentForm.get('localSISID')?.value;

        this.g_bAdvancedFieldsFilled = [msdVal, coeVal, msixVal, ssidVal, localSISIDVal].some(
            (value) => value !== undefined && value !== null && value.toString().trim() !== ''
        );

        return this.g_bAdvancedFieldsFilled;
    }

    validateFields() {
        this.myError = '';
        // Return true (valid) if at least one filled region/county/district/school OR at least two basic fields OR at least one advanced field
        if (this.chosenRegions?.length >= 1 || this.chosenCounties?.length >= 1 || this.chosenSchoolDistricts?.length >= 1 || this.chosenSchools?.length >= 1) {
            return true;
        }

        // Count filled form fields (excluding 'includeHardTerminations')
        const filledFieldsCount = Object.keys(this.searchStudentForm.controls).filter((key) => {
            if (key === 'includeHardTerminations') return false;
            const abstractContorl = this.searchStudentForm.get(key);
            return abstractContorl?.value !== undefined && abstractContorl?.value?.toString().trim() !== '';
        }).length;

        // Check if at least two basic fields are filled
        if (this.validateBasicFields()) {
            return true;
        }

        // Check if any advanced field is filled
        if (this.validateAdvFields()) {
            return true;
        }

        return false;
    }
    /*

    validateFields() {
        let retVal: boolean = true;

        if (this.chosenRegions?.length >= 1) retVal = false;
        else if (this.chosenCounties.length >= 1) retVal = false;
        else if (this.chosenSchoolDistricts.length >= 1) retVal = false;
        else if (this.chosenSchools.length >= 1) retVal = false;
        else {
            Object.keys(this.searchStudentForm.controls).forEach((key: string) => {
                const abstractContorl = this.searchStudentForm.get(key);
                if (key != 'includeHardTerminations' && abstractContorl?.value != undefined && abstractContorl?.value?.toString() != '') {
                    retVal = false;
                }
            });
        }        

        return retVal;
    }
        */

    validateBasicFields(): boolean {
        const basicFieldKeys = [
            'lastName',
            'firstName',
            'middleName',
            'secondLastName',
            'legalMotherFirstName',
            'birthCity',
            'startDate',
            'endDate',
            'motherFirstName',
            'motherLastName',
            'fatherFirstName',
            'fatherLastName',
            'birthState',
            'birthCountry',
            'gender'
        ];

        this.g_filledCount = basicFieldKeys.filter((key) => {
            const value = this.searchStudentForm.get(key)?.value;
            return value !== undefined && value !== null && value.toString().trim() !== '';
        }).length;

        if (this.chosenRegions && this.chosenRegions.length > 0) {
            this.g_filledCount++;
        }

        // Return true if AT LEAST 2 fields are filled
        return this.g_filledCount >= 2;
    }

    hasTwoFields(): boolean {
        let fieldCount = 0;

        const fields = [
            'msd',
            'coe',
            'msix',
            'ssid',
            'localSISID',
            'lastName',
            'firstName',
            'middleName',
            'secondLastName',
            'legalMotherFirstName',
            'birthCity',
            'startDate',
            'endDate',
            'motherFirstName',
            'motherLastName',
            'fatherFirstName',
            'fatherLastName',
            'birthState',
            'birthCountry',
            'gender'
        ];

        const advFields = ['msd', 'coe', 'msix', 'ssid', 'localSISID'];

        fieldCount += fields.map((field) => this.searchStudentForm.get(field)?.value).filter((v) => v != null && v !== '').length;

        if (advFields.map((field) => this.searchStudentForm.get(field)?.value).filter((v) => v != null && v !== '').length > 0) {
            fieldCount += 2;
        }

        if (this.chosenRegions?.length > 0 || this.chosenCounties?.length > 0 || this.chosenSchoolDistricts?.length > 0 || this.chosenSchools?.length > 0) {
            fieldCount++;
        }

        // Return true if AT LEAST 2 fields are filled
        return fieldCount >= 2;
    }

    listofRegionCode(regions: Region[]): string {
        let retString: string = '';
        for (let i = 1; i < regions.length; i++) {
            retString += regions[i].CODE;
            if (regions.length - 1 != i) {
                retString += ',';
            }
        }
        return retString;
    }

    // Shopping Cart functions
    shoppingCartAdd(obj: any) {
        this.shoppingCart.push(obj);

        this.updateDataSource();
        this.updateShoppingCartDataSource();

        this.saveBackup();
    }

    shoppingCartAddAll() {
        this.results.forEach((obj) => {
            let shoppingCartIndex = this.shoppingCart.findIndex((sc) => sc.ID === obj.ID);

            if (shoppingCartIndex === -1) {
                this.shoppingCart.push(obj);
            }
        });

        this.updateDataSource();
        this.updateShoppingCartDataSource();

        this.saveBackup();
    }

    shoppingCartRemove(obj: any) {
        let shoppingCartIndex = this.shoppingCart.findIndex((sc) => sc.ID === obj.ID);

        if (shoppingCartIndex >= 0) {
            this.shoppingCart.splice(shoppingCartIndex, 1);
        }

        this.updateDataSource();
        this.updateShoppingCartDataSource();

        this.saveBackup();
    }

    shoppingCartRemoveAll() {
        this.shoppingCart = [];

        this.updateDataSource();
        this.updateShoppingCartDataSource();

        this.saveBackup();
    }

    updateShoppingCartDataSource() {
        setTimeout(() => {
            this.shoppingCartTableDataSources = [];

            // Data
            let dataSource = new MatTableDataSource<any>();
            dataSource.data = this.shoppingCart;

            // Paginator
            dataSource.paginator = this.paginators.toArray()[1];

            // Sort
            dataSource.sort = this.sorts.toArray()[1];
            dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);
            if (this.shoppingCart.length === 0) {
                const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
                dataSource.sort.active = defaultSort.active;
                dataSource.sort.direction = defaultSort.direction;
                dataSource.sort.sortChange.emit(defaultSort);
            } else {
                dataSource.sort.sortChange.emit(this.sorts.toArray()[1]);
            }
            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.shoppingCartTableDataSources.push(dataSource);
            this.shoppingCartLength = this.shoppingCart.length;

            this.shoppingCartChange.emit(this.shoppingCart);
        }, 100);
    }

    setShoppingCartFilter() {
        this.shoppingCartTableDataSources.forEach((dataSource, index) => {
            dataSource.filter = this.shoppingCartFilter.trim().toLocaleLowerCase();
        });
    }

    // Backup functions
    getBackup() {
        this.helperService.currSessionTracking$.pipe(take(1)).subscribe((curSessionTrack) => {
            let searchRoute = curSessionTrack.routes
                ?.slice()
                .reverse()
                .find((x) => x.path == this.routePath);

            if (searchRoute != null) {
                if (searchRoute.path == '/children/group-communication-events' || searchRoute.path == '/children/group-enrollment') {
                    let searchCriteria = searchRoute?.searchCriterias.find((x) => x.screenName == 'secondTab');
                    let searchResult = searchRoute?.searchResults.find((x) => x.screenName == 'secondTab');
                    let chosenResult = searchRoute?.chosenResults.find((x) => x.screenName == 'secondTab');

                    if (searchCriteria != null) {
                        let workingShoppingCart: any = {
                            //SearchCriterias: {},
                            SearchCriterias: {} as ChildSearchRequestDataView,
                            SearchResults: [],
                            ChosenResults: []
                        };

                        workingShoppingCart.SearchCriterias = JSON.parse(searchCriteria.payLoad);

                        workingShoppingCart.SearchResults = searchResult?.results.map((x) => x.ID);
                        workingShoppingCart.ChosenResults = chosenResult?.results.map((x) => x.ID);
                        this.shoppingCartBackup = workingShoppingCart;
                    }
                } else if (searchRoute.path == '/children/search') {
                    let workingShoppingCart: any = {
                        //SearchCriterias: {},
                        SearchCriterias: {} as ChildSearchRequestDataView,
                        SearchResults: [],
                        ChosenResults: []
                    };
                    workingShoppingCart.SearchCriterias = JSON.parse(searchRoute.searchCriterias[0].payLoad);
                    //workingShoppingCart.SearchResults = searchRoute.searchResults[0].results.map(x => x.ID);
                    //workingShoppingCart.ChosenResults = searchRoute.chosenResults[0].results.map(x => x.ID);;
                    this.shoppingCartBackup = workingShoppingCart;
                }
            }
        });

        // let shoppingCart: any = {};
        // shoppingCart = {
        //     CartId: 'GroupEnrollments',
        //     SearchCriterias:
        //         '{"chosenRegions":[18],"chosenCounties":[8],"chosenSchoolDistricts":[1],"chosenSchools":[],"schoolYear":"2019-20","rAttending":true,"rNotAttending":false,"expiredEligibility":true,"expiredQAD":false,"notWithdrawnFromSchool":false}',
        //     SearchResults: '[{"ID":1324277},{"ID":1287564},{"ID":1287563},{"ID":1287562},{"ID":1136061}]',
        //     ChosenResults: '[{"ID":1324277},{"ID":1287564},{"ID":1287563},{"ID":1287562},{"ID":1136061}]'
        // };
    }

    restoreSearchCriteriaFromBackup() {
        if (this.shoppingCartBackup.SearchCriterias) {
            // //console.warn(this.shoppingCartBackup.SearchCriterias);
            // const childSearchRequest = this.shoppingCartBackup.SearchCriterias;
            // this.firstName.value = childSearchRequest.studentFirstName;
            // this.lastName.value = childSearchRequest.studentLastName;
            // this.middleName.value = childSearchRequest.studentMiddleInitial;
            // this.secondLastName.value = childSearchRequest.studentSecondLastName;
            // childSearchRequest.studentAgeLimit = childSearchRequest.studentAgeLimit;

            // this.birthCity.value = childSearchRequest.studentCity;
            // this.birthCity.value = childSearchRequest.studentDOB;

            // this.msd.value = childSearchRequest.studentMsdNumber;
            // this.coe.value = childSearchRequest.coeNumber;
            // this.ssid.value = childSearchRequest.studentSSID;
            // this.localSISID.value = childSearchRequest.studentSISID;
            // this.msix.value = childSearchRequest.studentMSIX;

            // if (childSearchRequest.startDOBDate != null) {
            //     this.startDate.value = childSearchRequest.startDOBDate;
            //     this.endDate.value = childSearchRequest.endDOBDate;
            // } else this.startDate.value = childSearchRequest.startDOBDate;

            // if (childSearchRequest.legalMotherFirstName == null || childSearchRequest.legalMotherFirstName == '')
            //     this.legalMotherFirstName.value = childSearchRequest.legalMotherFirstName;
            // else this.motherFirstName.value = childSearchRequest.legalMotherFirstName;

            // this.motherLastName.value = childSearchRequest.legalMotherLastName;
            // this.fatherFirstName.value = childSearchRequest.legalFatherFirstName;
            // this.fatherLastName.value = childSearchRequest.legalFatherLastName;

            // this.birthState.value = childSearchRequest.studentState;
            // this.birthCountry.value = childSearchRequest.studentCountry;
            // this.gender.value = childSearchRequest.studentSex;

            // this.includeHardTerminations.value = childSearchRequest.terminationFlag;

            // this.selectRegionIds = childSearchRequest.chosenRegions;
            // this.selectCountyIds = childSearchRequest.chosenCounties;
            // this.selectSchoolDistrictIds = childSearchRequest.chosenSchoolDistricts;
            // this.selectSchoolIds = childSearchRequest.chosenSchools;

            const searchCriterias = this.shoppingCartBackup.SearchCriterias;

            const patch: any = {};
            if (searchCriterias?.studentFirstName) {
                patch.firstName = searchCriterias?.studentFirstName;
            }
            if (searchCriterias?.studentMiddleInitial) {
                patch.middleName = searchCriterias?.studentMiddleInitial;
            }
            if (searchCriterias?.studentLastName) {
                patch.lastName = searchCriterias?.studentLastName;
            }
            if (searchCriterias?.studentSecondLastName) {
                patch.secondLastName = searchCriterias?.studentSecondLastName;
            }
            if (searchCriterias?.studentCity) {
                patch.birthCity = searchCriterias?.studentCity;
            }
            if (searchCriterias?.startDOBDate) {
                patch.startDate = searchCriterias?.startDOBDate;
            }
            if (searchCriterias?.endDOBDate) {
                patch.endDate = searchCriterias?.endDOBDate;
            }
            if (searchCriterias?.studentMsdNumber) {
                patch.msd = searchCriterias?.studentMsdNumber;
            }
            if (searchCriterias?.studentMsdNumber) {
                patch.msd = searchCriterias?.studentMsdNumber;
            }
            if (searchCriterias?.coeNumber) {
                patch.coe = searchCriterias.coeNumber;
            }
            if (searchCriterias?.studentSSID) {
                patch.ssid = searchCriterias?.studentSSID;
            }
            if (searchCriterias?.studentSISID) {
                patch.localSISID = searchCriterias?.studentSISID;
            }
            if (searchCriterias?.studentMSIX) {
                patch.msix = searchCriterias?.studentMSIX;
            }
            if (searchCriterias?.legalMotherFirstName) {
                patch.motherFirstName = searchCriterias?.legalMotherFirstName;
            }
            if (searchCriterias?.legalMotherLastName) {
                patch.motherLastName = searchCriterias?.legalMotherLastName;
            }
            if (searchCriterias?.legalFatherFirstName) {
                patch.fatherFirstName = searchCriterias?.legalFatherFirstName;
            }
            if (searchCriterias?.legalFatherLastName) {
                patch.fatherLastName = searchCriterias?.legalFatherLastName;
            }
            if (searchCriterias?.studentState) {
                patch.birthState = searchCriterias?.studentState;
            }
            if (searchCriterias?.studentCountry) {
                patch.birthCountry = searchCriterias?.studentCountry;
            }
            if (searchCriterias?.studentSex) {
                patch.gender = searchCriterias?.studentSex;
            }
            if (searchCriterias?.terminationFlag) {
                patch.includeHardTerminations = searchCriterias?.terminationFlag;
            }
            if (Object.keys(patch).length > 0) {
                this.searchStudentForm.patchValue(patch);
            }

            this.chosenRegions = searchCriterias?.chosenRegions?.map((id: number) => ({ ID: id })) ?? [];

            setTimeout(() => {
                this.chosenCounties = searchCriterias?.chosenCounties?.map((id: number) => ({ ID: id })) ?? [];
                setTimeout(() => {
                    this.chosenSchoolDistricts = searchCriterias?.chosenSchoolDistricts?.map((id: number) => ({ ID: id })) ?? [];
                    setTimeout(() => {
                        this.chosenSchools = searchCriterias?.chosenSchools?.map((id: number) => ({ ID: id })) ?? [];
                    }, 1500);
                }, 1000);
            }, 500);

            // Expand panels if needed
            if (
                searchCriterias?.chosenCounties?.length > 0 ||
                searchCriterias?.chosenSchoolDistricts?.length > 0 ||
                searchCriterias?.chosenSchools?.length > 0
            ) {
                this.locationExpanded = true;
            }

            if (
                searchCriterias?.legalMotherFirstName ||
                searchCriterias?.legalMotherLastName ||
                searchCriterias?.legalFatherFirstName ||
                searchCriterias?.legalFatherLastName
            ) {
                this.familyExpanded = true;
            }

            if (searchCriterias?.studentState || searchCriterias?.studentCountry || searchCriterias?.studentSex) {
                this.personalExpanded = true;
            }
        }
    }

    restoreShoppingCart() {
        if (this.shoppingCartBackup.ChosenResults && this.shoppingCartBackup.ChosenResults.length > 0) {
            this.shoppingCart = [];
            //let chosenResults = this.shoppingCartBackup.ChosenResults.map((cr: any) => cr.ID);
            let chosenResults = this.shoppingCartBackup.ChosenResults;
            this.shoppingCart = this.results.filter((r) => chosenResults.includes(r.ID));

            this.updateDataSource();
            this.updateShoppingCartDataSource();

            this.shoppingCartBackup.ChosenResults = [];
        }
    }

    saveBackup() {
        let shoppingCartBackup: any = {};
        shoppingCartBackup.CartId = this.screenName;
        shoppingCartBackup.SearchCriterias = this.generateSearchCriteriasBackup();

        shoppingCartBackup.SearchResults = this.generateResultsBackup(this.results);
        shoppingCartBackup.ChosenResults = this.generateChosenResultsBackup(this.shoppingCart);

        const route = {} as Route;
        route.path = this.routePath;

        route.timeStamp = new Date().toLocaleString();
        route.bLastVisited = false;
        route.searchCriterias = [];
        route.searchResults = [];
        route.chosenResults = [];

        const searchCriteria = {} as SearchCriteria;
        searchCriteria.screenName = this.screenName;

        //searchCriteria.payLoad = JSON.stringify(shoppingCartBackup.SearchCriterias.payLoad);
        searchCriteria.payLoad = JSON.stringify([]);
        route.searchCriterias.push(searchCriteria);

        const searchResult = {} as SearchResult;
        searchResult.screenName = this.screenName;
        searchResult.results = shoppingCartBackup.SearchResults;
        route.searchResults.push(searchResult);

        const chosenResult = {} as SearchResult;
        chosenResult.screenName = this.screenName;
        chosenResult.results = shoppingCartBackup.ChosenResults;
        route.chosenResults.push(chosenResult);

        this.helperService.addCurrSessionTrackingRoute(route);

        this.localStorageReset[this.router.url] = false;
        localStorage.setItem('reset', JSON.stringify(this.localStorageReset));

        //this.helperService.setCurrSessionTracking(route);
        //this.helperService.addCurrSessionTrackingRoute(route);
    }

    generateSearchCriteriasBackup() {
        let searchCriterias: any = {};
        //
        searchCriterias.screenName = this.screenName;
        searchCriterias.payLoad = this.constructSearchRequest(true);

        searchCriterias.payLoad.chosenRegions = this.chosenRegions.map((obj) => obj.ID);
        searchCriterias.payLoad.chosenCounties = this.chosenCounties.map((obj) => obj.ID);
        searchCriterias.payLoad.chosenSchoolDistricts = this.chosenSchoolDistricts.map((obj) => obj.ID);
        searchCriterias.payLoad.chosenSchools = this.chosenSchools.map((obj) => obj.ID);

        // searchCriterias.schoolYear = this.selectedSchoolYear;

        // searchCriterias.rAttending = this.rAttending;
        // searchCriterias.rNotAttending = this.rNotAttending;

        // searchCriterias.expiredEligibility = this.expiredEligibility;
        // searchCriterias.expiredQAD = this.expiredQAD;
        // searchCriterias.notWithdrawnFromSchool = this.notWithdrawnFromSchool;

        // if (this.chosenGrade) {
        //     searchCriterias.chosenGrade = { ID: this.chosenGrade.ID };
        // }

        return searchCriterias;
    }

    generateResultsBackup(results: any[]) {
        return results.map((r) => {
            return { ID: r.ID };
        });
    }

    generateChosenResultsBackup(shoppingCart: any[]) {
        return shoppingCart.map((sc) => {
            return { ID: sc.ID };
        });
    }

    catchSearchError(err: any) {
        console.log('search by caught error:' + err);
        this.myError = 'No child results. Please check your input. Error during search:' + err;
    }

    get errorMsgText(): string {
        // for debug only
        //this.myError = '' + valBasic:' + this.validateBasicFields() + ',disableBtn:' + this.disableButton + ",valFields:" + this.validateFields() + ",valAdvFields:" + this.validateAdvFields() + ",g_bAdvFieldsFilled:" + this.g_bAdvancedFieldsFilled+ ",g_filledCount:" + this.g_filledCount;
        return this.myError || '';
    }

    get instructionMsgText(): string {
        this.myInstruction = 'Please enter at least two fields when doing a basic search.'; //'valBasic:' + this.validateBasicFields() + ',disableBtn:' + this.disableButton + ",valFields:" + this.validateFields() + ",valAdvFields:" + this.validateAdvFields() + ",g_bAdvFieldsFilled:" + this.g_bAdvancedFieldsFilled+ ",g_filledCount:" + this.g_filledCount;
        return this.myInstruction || '';
    }

    get lastName(): any {
        return this.searchStudentForm.get('lastName');
    }
    get firstName(): any {
        return this.searchStudentForm.get('firstName');
    }
    get middleName(): any {
        return this.searchStudentForm.get('middleName');
    }
    get secondLastName(): any {
        return this.searchStudentForm.get('secondLastName');
    }
    get legalMotherFirstName(): any {
        return this.searchStudentForm.get('legalMotherFirstName');
    }
    get birthCity(): any {
        return this.searchStudentForm.get('birthCity');
    }
    get startDate(): any {
        return this.searchStudentForm.get('startDate');
    }
    get endDate(): any {
        return this.searchStudentForm.get('endDate');
    }
    get includeHardTerminations(): any {
        return this.searchStudentForm.get('includeHardTerminations');
    }
    get msd(): any {
        return this.searchStudentForm.get('msd');
    }
    get coe(): any {
        return this.searchStudentForm.get('coe');
    }
    get msix(): any {
        return this.searchStudentForm.get('msix');
    }
    get ssid(): any {
        return this.searchStudentForm.get('ssid');
    }
    get localSISID(): any {
        return this.searchStudentForm.get('localSISID');
    }
    get motherFirstName(): any {
        return this.searchStudentForm.get('motherFirstName');
    }
    get motherLastName(): any {
        return this.searchStudentForm.get('motherLastName');
    }
    get fatherFirstName(): any {
        return this.searchStudentForm.get('fatherFirstName');
    }
    get fatherLastName(): any {
        return this.searchStudentForm.get('fatherLastName');
    }
    get birthState(): any {
        return this.searchStudentForm.get('birthState');
    }
    get birthCountry(): any {
        return this.searchStudentForm.get('birthCountry');
    }
    get gender(): any {
        return this.searchStudentForm.get('gender');
    }
}
